module.exports = __webpack_public_path__ + "img/2frm5.prt.68cb1a05.jpg";